// extracted by mini-css-extract-plugin
export default {"container":"ZoneStatus_container__xUrBE","status":"ZoneStatus_status__4yR62","icon":"ZoneStatus_icon__8k36t","iconBackground":"ZoneStatus_iconBackground__bM7vR"};